module.exports = __webpack_public_path__ + "img/xhs@2x.a64952ea.png";